module.exports = __webpack_public_path__ + "static/assets/a074b87512d063e854d109e95aebfeb5.gif";